<div class="box">
  <div class="box-row header mb-2">
    <app-header-bar [backRoute]="'/devices'" [title]="device?.name || 'mdm.title'" [autoTranslateTitle]="device === undefined"></app-header-bar>
  </div>
  <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
  @if (device) {
    <div class="card mb-3">
      <div class="card-body">
        <div class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-3">
          <div>
            <h5 class="card-title mb-1">{{ 'mdm.overview.title' | translate }}</h5>
            <p class="text-muted mb-0">{{ 'mdm.overview.subtitle' | translate }}</p>
          </div>
          <div class="text-md-end">
            <small class="text-muted text-uppercase">{{ 'mdm.lastConnection' | translate }}</small>
            <div class="fw-semibold" [innerHTML]="device.lastConnection | timeAgo"></div>
          </div>
        </div>

        <div class="row g-3">
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.name' | translate }}</small>
            <div class="fw-semibold">{{ device.name || '-' }}</div>
          </div>
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.deviceId' | translate }}</small>
            <div class="fw-semibold">{{ device.deviceId }}</div>
          </div>
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.handheldSerial' | translate }}</small>
            <div class="fw-semibold">{{ device.handheldSerial || '-' }}</div>
          </div>
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.user' | translate }}</small>
            <div class="fw-semibold">
              {{ device.occupyingWorker ? (device.occupyingWorker.family_name + ' ' + device.occupyingWorker.given_name) : '-' }}
            </div>
          </div>
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.localIpAddress' | translate }}</small>
            <div class="fw-semibold">{{ device.localIpAddress || '-' }}</div>
          </div>
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.os' | translate }}</small>
            <div class="fw-semibold">{{ device.os || '-' }}</div>
          </div>
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.osBuildNumber' | translate }}</small>
            <div class="fw-semibold">{{ device.osBuildNumber || '-' }}</div>
          </div>
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.appVersion' | translate }}</small>
            <div class="fw-semibold">{{ device.appVersion || '-' }}</div>
          </div>
          <div class="col-6 col-md-6 col-xl-3">
            <small class="text-muted text-uppercase">{{ 'mdm.coreLibraryVersion' | translate }}</small>
            <div class="fw-semibold">{{ device.coreLibraryVersion || '-' }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="accordion" id="mdm-detail-accordion">
      <div class="accordion-item">
        <h2 class="accordion-header" id="mdm-activity-heading">
          <button
            class="accordion-button"
            [class.collapsed]="!isSectionOpen('activity')"
            type="button"
            (click)="toggleSection('activity')"
            [attr.aria-expanded]="isSectionOpen('activity')"
            aria-controls="mdm-activity-body"
          >
            {{ 'mdm.detailSections.activity' | translate }}
          </button>
        </h2>
        <div
          id="mdm-activity-body"
          class="accordion-collapse collapse"
          [class.show]="isSectionOpen('activity')"
          aria-labelledby="mdm-activity-heading"
        >
          <div class="accordion-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.user' | translate }}</h6>
                <div>
                  {{ device.occupyingWorker ? (device.occupyingWorker.family_name + ' ' + device.occupyingWorker.given_name) : '-' }}
                </div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.organization' | translate }}</h6>
                <div>{{ device.organization.name || '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.lastConnection' | translate }}</h6>
                <div [innerHTML]="device.lastConnection | timeAgo"></div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.createdAt' | translate }}</h6>
                <div>{{ device.createdAt | dateTime }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.lastUpdatedAt' | translate }}</h6>
                <div>{{ device.lastUpdatedAt | dateTime }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="mdm-software-heading">
          <button
            class="accordion-button"
            [class.collapsed]="!isSectionOpen('software')"
            type="button"
            (click)="toggleSection('software')"
            [attr.aria-expanded]="isSectionOpen('software')"
            aria-controls="mdm-software-body"
          >
            {{ 'mdm.detailSections.software' | translate }}
          </button>
        </h2>
        <div
          id="mdm-software-body"
          class="accordion-collapse collapse"
          [class.show]="isSectionOpen('software')"
          aria-labelledby="mdm-software-heading"
        >
          <div class="accordion-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.os' | translate }}</h6>
                <div>{{ device.os || '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.osVersion' | translate }}</h6>
                <div>{{ device.osVersion || '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.osBuildNumber' | translate }}</h6>
                <div>{{ device.osBuildNumber || '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.appVersion' | translate }}</h6>
                <div>{{ device.appVersion || '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.coreLibraryVersion' | translate }}</h6>
                <div>{{ device.coreLibraryVersion || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="mdm-hardware-heading">
          <button
            class="accordion-button"
            [class.collapsed]="!isSectionOpen('hardware')"
            type="button"
            (click)="toggleSection('hardware')"
            [attr.aria-expanded]="isSectionOpen('hardware')"
            aria-controls="mdm-hardware-body"
          >
            {{ 'mdm.detailSections.hardware' | translate }}
          </button>
        </h2>
        <div
          id="mdm-hardware-body"
          class="accordion-collapse collapse"
          [class.show]="isSectionOpen('hardware')"
          aria-labelledby="mdm-hardware-heading"
        >
          <div class="accordion-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.name' | translate }}</h6>
                <div>{{ device.name || '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.deviceId' | translate }}</h6>
                <div>{{ device.deviceId }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.handheldSerial' | translate }}</h6>
                <div>{{ device.handheldSerial || '-' }}</div>
              </div>
              <div class="col-12 col-md-6">
                <h6 class="fw-bold mb-1">{{ 'mdm.localIpAddress' | translate }}</h6>
                <div>{{ device.localIpAddress || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="accordion-item">
        <h2 class="accordion-header" id="mdm-metadata-heading">
          <button
            class="accordion-button"
            [class.collapsed]="!isSectionOpen('metadata')"
            type="button"
            (click)="toggleSection('metadata')"
            [attr.aria-expanded]="isSectionOpen('metadata')"
            aria-controls="mdm-metadata-body"
          >
            {{ 'mdm.detailSections.additionalData' | translate }}
          </button>
        </h2>
        <div
          id="mdm-metadata-body"
          class="accordion-collapse collapse"
          [class.show]="isSectionOpen('metadata')"
          aria-labelledby="mdm-metadata-heading"
        >
          <div class="accordion-body">
            @if (parsedAdditionalData.length > 0) {
              <div class="row g-3">
                @for (entry of parsedAdditionalData; track entry[0]) {
                  <div class="col-12 col-md-6">
                    <h6 class="fw-bold mb-1">{{ entry[0] }}</h6>
                    <div>{{ entry[1] }}</div>
                  </div>
                }
              </div>
            } @else {
              <p class="mb-0 text-muted fst-italic">
                {{ 'mdm.emptyStates.additionalData' | translate }}
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  }
  <app-error [error]="error"></app-error>
</div>
